import React, {Component} from 'react';
import {connect} from 'react-redux';
import './style.css';
import TripList from "./TripList";
import AdmissionTime from "./AdmissionTime";
import {url_server} from "../../constants/server";
import {setRouteDisp, setFetchState} from "../../actions";
import {translateLang, translateRoute} from "../../constants/traductions";

class CalendarLeft extends Component {

  constructor() {
    super();

    this.state = {
      show_trips: false,
      show_time: true,
      current_trip: {
        id: 0,
        name: "MACHUPICCHU"
      },
      new_trip_selected: false
    };

  }

  formatRealTridID(stime) {

    let real_trip_id = 100; // Machupicchu - 6:00

    let trip = this.state.current_trip.id;
    let time = stime;

    if (trip === 0) { // Machupicchu
      if (time === '06:00 - 07:00') { real_trip_id = 100 }
      if (time === '07:00 - 08:00') { real_trip_id = 101 }
      if (time === '08:00 - 09:00') { real_trip_id = 102 }
      if (time === '09:00 - 10:00') { real_trip_id = 103 }
      if (time === '10:00 - 11:00') { real_trip_id = 104 }
      if (time === '11:00 - 12:00') { real_trip_id = 105 }
      if (time === '12:00 - 13:00') { real_trip_id = 106 }
      if (time === '13:00 - 14:00') { real_trip_id = 107 }
      if (time === '14:00 - 15:00') { real_trip_id = 108 }
    }
    // if (trip === 1) {
    //   if (time === '06:00 - 07:00') { real_trip_id = 120 }
    //   if (time === '07:00 - 08:00') { real_trip_id = 121 }
    //   if (time === '08:00 - 09:00') { real_trip_id = 122 }
    // }
    // if (trip === 2) {
    //   if (time === '06:00 - 07:00') { real_trip_id = 110 }
    //   if (time === '07:00 - 08:00') { real_trip_id = 111 }
    //   if (time === '08:00 - 09:00') { real_trip_id = 112 }
    // }
    if (trip === 5) {
      if (time === '07:00 - 08:00') { real_trip_id = 111 }
      if (time === '08:00 - 09:00') { real_trip_id = 112 }
      if (time === '09:00 - 10:00') { real_trip_id = 113 }
      if (time === '10:00 - 11:00') { real_trip_id = 114 }
    }
    if (trip === 6) {
      if (time === '07:00 - 08:00') { real_trip_id = 121 }
      if (time === '08:00 - 09:00') { real_trip_id = 122 }
    }
    if (trip === 7) {
      if (time === '07:00 - 08:00') { real_trip_id = 131 }
      if (time === '08:00 - 09:00') { real_trip_id = 132 }
      if (time === '09:00 - 10:00') { real_trip_id = 133 }
      if (time === '10:00 - 11:00') { real_trip_id = 134 }
      if (time === '11:00 - 12:00') { real_trip_id = 135 }
      if (time === '12:00 - 13:00') { real_trip_id = 136 }
    }
    if (trip === 8) {
      if (time === '07:00 - 08:00') { real_trip_id = 141 }
      if (time === '08:00 - 09:00') { real_trip_id = 142 }
      if (time === '09:00 - 10:00') { real_trip_id = 143 }
      if (time === '10:00 - 11:00') { real_trip_id = 144 }
      if (time === '11:00 - 12:00') { real_trip_id = 145 }
      if (time === '12:00 - 13:00') { real_trip_id = 146 }
      if (time === '13:00 - 14:00') { real_trip_id = 147 }
      if (time === '14:00 - 15:00') { real_trip_id = 148 }
    }

    return real_trip_id;

  }

  getSelectedTrip = async childData => {

    // console.log(childData)

    // si las rutas son : [3: Camino Inka - Rutas 01, 02 y 03, 4: Camino Inka - Ruta 05]
    if (childData.id === 3 || childData.id === 4) {

      this.setState({
        current_trip: childData,
        show_trips: false,
        show_time: false,
        new_trip_selected: true
      });

      // marcar estado de fetching en true
      this.props.setFetchState({
        fetchingState: true
      });

      let data = await (this.getDataFromServer(childData.id === 3 ? 1 : 4));

      // marcar estado de fetching en false
      this.props.setFetchState({
        fetchingState: false
      });

      this.props.setRouteDisp({
        idRuta: childData.id === 3 ? 1 : 4,
        dataDisp: data ? data : []
      });

    }
    else {

      this.setState({
        current_trip: childData,
        show_trips: false,
        show_time: true,
        new_trip_selected: true
      });

      // auto seleccionar primer horario
      // marcar estado de fetching en true
      this.props.setFetchState({
        fetchingState: true
      });

      let valor_id = 1;
      if (childData.id === 5) valor_id = 111; // primer horario de 7 a 8
      else if (childData.id === 6) valor_id = 121; // primer horario de 7 a 8
      else if (childData.id === 7) valor_id = 131; // primer horario de 7 a 8
      else if (childData.id === 8) valor_id = 141; // primer horario de 7 a 8

      let data = await (this.getDataFromServer(valor_id));

      // marcar estado de fetching en false
      this.props.setFetchState({
        fetchingState: false
      });

      this.props.setRouteDisp({
        idRuta: valor_id,
        dataDisp: data ? data : []
      });

    }

  };

  getSelectedTime = async stime => {

    let real_id = this.formatRealTridID(stime);

    // marcar estado de fetching en true
    this.props.setFetchState({
      fetchingState: true
    });

    let data = await (this.getDataFromServer(real_id));

    // marcar estado de fetching en false
    this.props.setFetchState({
      fetchingState: false
    });

    this.props.setRouteDisp({
      idRuta: real_id,
      dataDisp: data ? data : []
    });

  };

  async getDataFromServer(real_id) {

    let data;

    try {

      const res = await fetch(`${url_server}/boleto/disponibilidad`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          "idRuta": real_id,
          "mes": parseInt(this.props.store.mes) + 1, // el mes es del 1 al 12 en el server
          "anio": this.props.store.anio
        })
      });

      data = await res.json();

      return data;

    } catch (e) {
      console.error(e)
    }

  }

  showTrips() {

    this.setState({
      show_trips: !this.state.show_trips,
      show_time: false,
    });

  }

  render() {

    const {show_trips, show_time} = this.state;

    return (
      <section className="calendar-left">
        <div className="sidebar">

          <div className={show_trips ? 'btn-trip-selector btn-active' : 'btn-trip-selector'}
               onClick={() => this.showTrips()}>

            <p className="subheading">
              { translateLang('btn_selector_ruta', this.props.store.language) }
            </p>

          </div>

          <div style={{ marginTop: '10px', marginBottom: '10px' }}>
            <p className="trip-center">
              { translateRoute(this.state.current_trip.id, this.props.store.language) }
            </p>
          </div>

          {show_trips ? <TripList parentCallback={this.getSelectedTrip} /> : ''}

          {show_time ?
            <AdmissionTime parentCallback={this.getSelectedTime}
                           trip={this.state.current_trip}
                           nts={this.state.new_trip_selected}
            />
            : ''}

        </div>
      </section>
    );

  }

}

const mapStateToProps = store => ({
  store
});
const mapDispatchToProps = dispatch => ({
  setRouteDisp: value => dispatch(setRouteDisp(value)),
  setFetchState: value => dispatch(setFetchState(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarLeft);
